import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Container, Content, Header, Loader, DatePicker } from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import { CommercialScheduleServices } from "../../../core/services/CommercialScheduleServices";
import "./CommercialSchedule.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import CommercialScheduleStoresModal from "./CommercialScheduleStoresModal";
import {
  messageTypeArr,
  roleTypeArr,
  yesNoObjArr,
  dateFormatObj,
  fullDayTimeObjArr,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  calenderDateToDB,
  compareTimes,
  countCommaSeparatedVals,
  dbDateToCalender,
  isEmptyVal,
  isNotNull,
} from "../../../utils/helpers";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import CommercialScheduleStores from "./CommercialScheduleStores";
function CommercialSchedule() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedStores, setSelectedStores] = useState<any[]>([]);
  const [reloadKey, setReloadKey] = useState(0);
  const [openModalByName, setOpenModalByName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoading] = useState(false);
  const params: any = useParams();
  const company = useSelector((state: any) => state.company);
  const [storeIds, setStoreIds] = useState("");
  const [openDayChangeModal, setOpenDayChangeModal] = useState(false);
  const [formData, setFormData] = useState<any>({
    name: "",
    company_id: "",
    schedule_starts_at: "",
    schedule_ends_at: "",
    new_schedule_everyday: "",
    max_items: "",
    schedule_date_from: "",
    schedule_date_to: "",
    store_ids: "",
    status: "",
  });

  const [scheduleData, setScheduleData] = useState<any>({
    name: "",
    company_id: "",
    schedule_starts_at: "",
    schedule_ends_at: "",
    new_schedule_everyday: "",
    max_items: "",
    schedule_date_from: "",
    schedule_date_to: "",
    store_ids: "",
    status: "",
  });

  let [decryptedParams] = useDecryptedParams(params);

  useEffect(() => {
    if (decryptedParams?.id !== undefined) {
      refreshStores();
    }
  }, [decryptedParams]);

  const handleScheduleStores = (scheduleId: any) => {
    setOpenModalByName("view-commercial-schedule-stores");
  };

  function refreshStores() {
    setReloadKey((prevKey) => prevKey + 1);
  }

  async function init() {
    try {
      if (decryptedParams.id) {
        const response: any =
          await CommercialScheduleServices.viewCommercialSchedule(
            +decryptedParams.id
          );
        const respData = get("data.data", response);
        const keyMapper: any = { name: "schedule_title" };

        let obj = { ...formData };

        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKeys) => {
          if (keyMapperIndex.includes(formKeys)) {
            obj[formKeys] = respData[keyMapper[formKeys]];
          } else if (formKeys === "schedule_date_from") {
            obj["schedule_date_from"] = isEmptyVal(
              respData["schedule_date_from"]
            )
              ? null
              : dbDateToCalender(respData["schedule_date_from"]);
          } else if (formKeys === "schedule_date_to") {
            obj["schedule_date_to"] = isEmptyVal(respData["schedule_date_to"])
              ? null
              : dbDateToCalender(respData["schedule_date_to"]);
          } else if (formKeys === "status") {
            obj[formKeys] = respData?.status.toString();
          } else if (formKeys === "schedule_starts_at") {
            obj[formKeys] = isEmptyVal(respData["schedule_starts_at"])
              ? null
              : respData["schedule_starts_at"].substring(0, 5);
          } else if (formKeys === "schedule_ends_at") {
            obj[formKeys] = isEmptyVal(respData["schedule_ends_at"])
              ? null
              : respData["schedule_ends_at"].substring(0, 5);
          } else if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
        });
        setFormData({ ...obj });
        setScheduleData(obj);
        setStoreIds(respData?.store_ids);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      navigate(ContentRoutes.COMMERCIAL_SCHEDULES);
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {}, []);

  useEffect(() => {}, [company.id]);

  function handleScheduleDayChange(dayType?: string) {
    if (!decryptedParams.id) return;
    if (dayType == scheduleData.new_schedule_everyday) return;
    setOpenDayChangeModal(true);
  }

  async function saveCommercialSchedule(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await CommercialScheduleServices.updateCommercialSchedule(
          +id,
          form
        );
      } else {
        response = await CommercialScheduleServices.createCommercialSchedule(
          form
        );
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.COMMERCIAL_SCHEDULES);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    const formStoreIds = [...storeIds.split(","), ...selectedStores].filter(
      (item) => item !== ""
    );

    for (var key in formData) {
      if (key == "schedule_date_from" && !isEmptyVal(val[key])) {
        form.append("schedule_date_from", calenderDateToDB(val[key]));
      } else if (key == "schedule_date_to" && !isEmptyVal(val[key])) {
        form.append("schedule_date_to", calenderDateToDB(val[key]));
      } else if (isNotNull(val[key])) {
        form.append(key, val[key]);
      }
    }

    if (!getCompanyId() && !decryptedParams.id) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
      });
      return;
    }
    if (formStoreIds.length < 1) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("STORE").toLowerCase(),
        }),
      });
      return;
    }
    if (selectedStores.length > 0) {
      form.append("store_ids", formStoreIds.join(","));
    }
    if (decryptedParams.id) {
      saveCommercialSchedule(form, decryptedParams.id);
    } else {
      form.set("company_id", getCompanyId());
      saveCommercialSchedule(form);
    }
  };
  return (
    <div className="commercial-schedule">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content="Loading..."
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header mb-2">
          <h4>
            {decryptedParams.id ? t("UPDATE") : t("CREATE")}{" "}
            {t("COMMERCIAL_SCHEDULE")}
          </h4>
        </Header>
        <Content className="content commercial-schedule-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.name) {
                errors.name = t("REQUIRED", {
                  field: t("NAME").toLowerCase(),
                });
              }
              if (!values.schedule_starts_at) {
                errors.schedule_starts_at = t("REQUIRED", {
                  field:
                    t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
                });
              }
              if (!values.schedule_ends_at) {
                errors.schedule_ends_at = t("REQUIRED", {
                  field: t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
                });
              }
              if (
                values.schedule_starts_at &&
                values.schedule_ends_at &&
                compareTimes(
                  values.schedule_ends_at,
                  values.schedule_starts_at
                ) < 1
              ) {
                errors.schedule_ends_at = t(
                  "DATE2_SHALL_BE_GREATER_THAN_DATE1",
                  {
                    date2:
                      t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
                    date1:
                      t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
                  }
                );
              }
              if (values.new_schedule_everyday === "") {
                errors.new_schedule_everyday = t("REQUIRED", {
                  field:
                    t("NEW").toLowerCase() +
                    " " +
                    t("SCHEDULE").toLowerCase() +
                    " " +
                    t("EVERYDAY").toLowerCase(),
                });
              }
              if (!values.max_items) {
                errors.max_items = t("REQUIRED", {
                  field:
                    t("MAX").toLowerCase() + " " + t("ITEMS").toLowerCase(),
                });
              }
              if (values.max_items < 1) {
                errors.max_items = t("VALID", {
                  entity:
                    t("MAX").toLowerCase() + " " + t("ITEMS").toLowerCase(),
                });
              }
              if (!values.schedule_date_from) {
                errors.schedule_date_from = t("REQUIRED", {
                  field:
                    t("SCHEDULE").toLowerCase() +
                    " " +
                    t("START").toLowerCase() +
                    " " +
                    t("DATE").toLowerCase(),
                });
              }
              if (!values.schedule_date_to) {
                errors.schedule_date_to = t("REQUIRED", {
                  field:
                    t("SCHEDULE").toLowerCase() +
                    " " +
                    t("END").toLowerCase() +
                    " " +
                    t("DATE").toLowerCase(),
                });
              }
              if (
                values.schedule_date_from &&
                values.schedule_date_to &&
                new Date(values.schedule_date_to) <
                  new Date(values.schedule_date_from)
              ) {
                errors.schedule_date_to = t(
                  "DATE2_SHALL_BE_GREATER_THAN_DATE1",
                  {
                    date2:
                      t("END").toLowerCase() + " " + t("DATE").toLowerCase(),
                    date1:
                      t("START").toLowerCase() + " " + t("DATE").toLowerCase(),
                  }
                );
              }

              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => setFormData(values)}
                />
                <form onSubmit={handleSubmit}>
                  <div className="form-part">
                    <div className="flex-container">
                      <Field name="name">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>{t("NAME")}*</label>
                            <input {...input} type="text" />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>

                      <Field name="new_schedule_everyday">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={
                                t("NEW") +
                                " " +
                                t("SCHEDULE") +
                                " " +
                                t("EVERYDAY")
                              }
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("new_schedule_everyday", "");
                              }}
                              listData={yesNoObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("new_schedule_everyday", e);
                                handleScheduleDayChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="schedule_starts_at">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={false}
                              valueKey="value"
                              labelKey="label"
                              isDisable={false}
                              labelName={t("STARTS") + " " + t("AT")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("schedule_starts_at", "");
                              }}
                              listData={fullDayTimeObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("schedule_starts_at", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="schedule_ends_at">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={false}
                              valueKey="value"
                              labelKey="label"
                              isDisable={false}
                              labelName={t("ENDS") + " " + t("AT")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("schedule_ends_at", "");
                              }}
                              listData={fullDayTimeObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("schedule_ends_at", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex-container">
                      <Field name="max_items">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("MAX")} {t("ITEMS")}*
                            </label>
                            <input
                              {...input}
                              type="number"
                              autoComplete="off"
                              min="1"
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="schedule_date_from">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("SCHEDULE")} {t("START")} {t("DATE")}
                            </label>
                            <DatePicker
                              value={input.value || null}
                              defaultValue={formData?.schedule_date_from}
                              format={dateFormatObj.calendar_d_m_y}
                              name="schedule_date_from"
                              id="schedule_date_from"
                              onChange={(e: any) => {
                                form.change("schedule_date_from", e);
                                handleDateChange(e, "schedule_date_from");
                                input.onChange(e);
                              }}
                              onClean={(event: any) => {
                                form.change("schedule_date_from", "");
                                handleDateChange("", "schedule_date_from");
                                input.onChange("");
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="schedule_date_to">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("SCHEDULE")} {t("END")} {t("DATE")}
                            </label>
                            <DatePicker
                              value={input.value || null}
                              defaultValue={formData?.schedule_date_to}
                              format={dateFormatObj.calendar_d_m_y}
                              name="schedule_date_to"
                              id="schedule_date_to"
                              onChange={(e: any) => {
                                form.change("schedule_date_to", e);
                                handleDateChange(e, "schedule_date_to");
                                input.onChange(e);
                              }}
                              onClean={(event: any) => {
                                form.change("schedule_date_to", "");
                                handleDateChange("", "schedule_date_to");
                                input.onChange("");
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  </div>
                  <div className="address-bx">
                    <h5>
                      {t("SELECT") + " " + t("STORES")}
                      {decryptedParams?.id > 0 && !isEmptyVal(storeIds) && (
                        <label>
                          <a
                            onClick={() => {
                              handleScheduleStores(decryptedParams?.id);
                            }}
                          >
                            {t("    ")} {t("VIEW")} {t("EXISTING")}{" "}
                            {countCommaSeparatedVals(storeIds)} {t("STORES")}
                          </a>
                        </label>
                      )}
                    </h5>
                  </div>
                  <div className="form-part">
                    {getCompanyId() > 0 && decryptedParams && (
                      <CommercialScheduleStores
                        companyId={getCompanyId()}
                        withHeader={false}
                        key={reloadKey}
                        enableBulkAction={["none"]}
                        setSelectedStores={setSelectedStores}
                        {...(decryptedParams.id > 0
                          ? { excludeCommercialSchedule: decryptedParams.id }
                          : {})}
                      />
                    )}
                  </div>

                  <div className="create-action d-flex flex-end">
                    <Link to={ContentRoutes.COMMERCIAL_SCHEDULES}>
                      <Button appearance="primary" color="red" type="button">
                        {t("CANCEL")}
                      </Button>
                    </Link>
                    <Button appearance="primary" color="green" type="submit">
                      {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                    </Button>
                    <Button
                      appearance="default"
                      type="reset"
                      onClick={() => {
                        form.reset();
                      }}
                    >
                      {t("RESET")}
                    </Button>
                  </div>
                </form>
              </>
            )}
          />
        </Content>
      </Container>
      {openModalByName === "view-commercial-schedule-stores" && (
        <CommercialScheduleStoresModal
          commercialScheduleId={decryptedParams?.id}
          commercialScheduleData={scheduleData}
          openModal={
            openModalByName === "view-commercial-schedule-stores" ? true : false
          }
          setOpenModal={setOpenModalByName}
          onDeleteStores={refreshStores}
          enableBulkAction={["delete"]}
        />
      )}

      <AlertModal
        open={openDayChangeModal}
        handleClose={(e: any) => {
          if (e == true) {
            setOpenDayChangeModal(false);
          } else {
            setFormData({
              ...formData,
              ...{ new_schedule_everyday: scheduleData.new_schedule_everyday },
            });
            setOpenDayChangeModal(false);
          }
        }}
        displayText={t("CONFIRM_SCHEDULE_EVERYDAY_CHANGE", {
          items: t("ITEMS").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("CHANGE").toLowerCase(),
        })}
      />
    </div>
  );
}

export default CommercialSchedule;
